import React from "react";

import { OperatorSelectPlan } from "app/plans/modules/operator/features";

const SelectPlan = () => {
  return <OperatorSelectPlan />;
};

export default SelectPlan;
